import { computed, nextTick, onBeforeUnmount, onMounted, ref } from '@vue/composition-api';
import elementResizeDetectorMaker from 'element-resize-detector';
import debounce from 'debounce';
import { DsrConstants } from '../constants';

export enum DSRLayout {
  ShowAll = 'ShowAll',
  HideRightSide = 'HideRightSide',
  HideBothSides = 'HideBothSides',
  ContentOnly = 'ContentOnly',
}

export function useLayout() {
  const totalContentPadding = DsrConstants.contentPadding * 2;
  const totalRightWidth = DsrConstants.rightSideWidth + DsrConstants.sideMargin;
  const totalLeftWidth = DsrConstants.navigationWidth + DsrConstants.sideMargin;

  const layout = ref(DSRLayout.ShowAll);
  const elementResizeDetector = elementResizeDetectorMaker({
    strategy: 'scroll',
  });

  const updateDSRLayout = () => {
    if (
      document.body.offsetWidth - (totalLeftWidth + totalRightWidth + totalContentPadding) >=
      600
    ) {
      layout.value = DSRLayout.ShowAll;
    } else if (document.body.offsetWidth - (totalLeftWidth + totalContentPadding) >= 600) {
      layout.value = DSRLayout.HideRightSide;
    } else if (document.body.offsetWidth > 600) {
      layout.value = DSRLayout.HideBothSides;
    } else {
      layout.value = DSRLayout.ContentOnly;
    }
  };

  const showRightSide = computed(
    () =>
      ![DSRLayout.HideRightSide, DSRLayout.HideBothSides, DSRLayout.ContentOnly].includes(
        layout.value
      )
  );
  const showLeftSide = computed(
    () => ![DSRLayout.HideBothSides, DSRLayout.ContentOnly].includes(layout.value)
  );
  const hideContentPadding = computed(() => layout.value === DSRLayout.ContentOnly);

  onMounted(async () => {
    await nextTick();
    elementResizeDetector.listenTo(document.body, debounceUpdateLayout);
  });

  onBeforeUnmount(() => {
    elementResizeDetector?.removeListener(document.body);
  });

  const debounceUpdateLayout = debounce(updateDSRLayout, 200);

  return {
    updateDSRLayout,
    hideContentPadding,
    showRightSide,
    showLeftSide,
  };
}
